import { useEffect, useState } from "react"
import { simplifyUrl } from "@/utils/url"

export interface AvatarProps {
  src?: string
  label: string
  size?: number
  className?: string
}

/** Avatar with a deterministic gradient fallback when there is no picture. */
export function Avatar({ src, label, size = 40, className = "" }: AvatarProps) {
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [src])

  const initials = label
    .replace(/^wss?:\/\//, "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .slice(0, 2)
    .toUpperCase()

  const hue = [...label].reduce((sum, char) => sum + char.charCodeAt(0), 0) % 360

  if (!src || failed) {
    return (
      <span
        className={`avatar avatar-fallback ${className}`}
        style={{
          width: size,
          height: size,
          fontSize: Math.max(10, size * 0.36),
          background: `linear-gradient(135deg, hsl(${hue} 55% 52%), hsl(${(hue + 45) % 360} 60% 38%))`,
        }}
        aria-hidden="true"
      >
        {initials || "?"}
      </span>
    )
  }

  return (
    <img
      className={`avatar ${className}`}
      src={src}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  )
}

export interface RelayIconProps {
  url: string
  icon?: string
  size?: number
}

/** Relay icon: the NIP-11 `icon` when present, otherwise the relay initials. */
export function RelayIcon({ url, icon, size = 28 }: RelayIconProps) {
  return <Avatar src={icon} label={simplifyUrl(url)} size={size} className="relay-avatar" />
}
